const modalOverlay = document.getElementById('modalOverlay');

function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Close modal when clicking outside
modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
        closeModal();
    }
});

// Close modal on ESC key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
        closeModal();
    }
});


$( document ).ready(function() {
    $('#ebook-form').submit(function(evt){
        evt.preventDefault(); // Prevent form submission
        var formData = {
            fname:   $("#fullName").val(),
            email:   $("#email").val(),
            company:   $("#company").val(),
            phone:   $("#phone").val(),
            message: $("#message").val()
            
        };

        $.ajax({
            type: "POST",
            url: "../../inc/process-ebook.php",
            data: formData,
            dataType: "json",
            encode: true,
        }).done(function (data) {
            console.log(data);
            
            // Validation
            if (!data.success) {
                
            } else {
                $('.modal-content .success-message').css('display', 'block');
                $('.modal-content .modal-inner').css('display', 'none');
                setTimeout(function() {
                    closeModal();
                },2000);
                
            }
            
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error: " + textStatus);
            console.error(errorThrown);
        });
        
    });
});